import {
  ELEMENT_ATTRIBUTE_GROUP,
  ELEMENT_GROUPS,
  markupDescription
} from './../utils';

const RadioButtonGroupElementFields = {
  group: ELEMENT_GROUPS.FORMS,
  label: 'Form Radio Options',
  icon: 'DocumentTextIcon',
  description: 'Adds a radio button panel',
  properties: [
    {
      label: 'Data Binding Source',
      name: 'datasourceId',
      description: 'Choose a content type this element will get its data from',
      editor: 'dropdown',
      function: {
        name: 'getDynamicDataSources',
        params: ['app.id']
      },
      default: '',
      displayWhen: [],
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    },
    {
      label: 'Data Binding Field',
      name: 'sourceField',
      editor: 'dropdown',
      description:
        'The field from the underlying datasource will be used as the value of this element',
      default: '',
      options: [],
      function: {
        name: 'getDynamicDataSourceFields',
        params: ['app.id', 'element.datasourceId']
      },
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    },
    {
      label: 'On Selection Action',
      name: 'action',
      editor: 'dropdown',
      default: '',
      description: 'An action to run one of the radio options is pressed.',
      options: [],
      function: {
        name: 'getAppActions',
        params: ['app.id']
      },

      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    },
    {
      label: 'Data Binding Markup',
      name: 'datasourceFieldMarkup',
      editor: 'textbox',
      description: markupDescription,
      default: '',
      options: [],
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    },
    'layout',
    'margin',
    'padding',
    {
      label: 'Update Local Store',
      name: 'updateLocalStore',
      editor: 'switch',
      description:
        'If true, the selected value will be stored in the local store',
      default: '',
      options: [],
      function: {
        name: 'getContentTypes',
        values: [],
        params: []
      },
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    },
    {
      label: 'Local Store Key',
      name: 'localStoreKey',
      editor: 'textbox',
      description:
        'A key to use to store the selected value against in the local store.',
      default: '',
      displayWhen: [{ field: 'updateLocalStore', operator: '=', value: true }],
      options: [],
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    },
    {
      label: 'Use Options from a Data Source',
      name: 'useDataSourceOptions',
      editor: 'switch',
      description:
        'If true, will use a options loaded from a data source instead of static options',
      default: false,
      options: [],
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    },
    {
      label: 'Enabled Multiple Selections',
      name: 'enableMultipleSelections',
      editor: 'switch',
      description:
        'If true, multiple items can be selected (behaves like a set of checkboxes) as opposed to a radio button group',
      default: false,
      options: [],
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    },
    {
      label: 'Options Data Source',
      name: 'optionsDataSource',
      editor: 'dropdown',
      description: 'The type of record where the options can be loaded from',
      default: '',
      options: [],
      function: {
        name: 'getContentTypes',
        values: [],
        params: []
      },
      displayWhen: [
        { field: 'useDataSourceOptions', operator: '=', value: true }
      ],
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    },
    {
      label: 'Options Collection Path',
      name: 'optionsCollectionPath',
      editor: 'textbox',
      description:
        'The firestore path to the collection that contains the options',
      default: '',
      options: [],
      displayWhen: [
        { field: 'useDataSourceOptions', operator: '=', value: true }
      ],
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    },
    {
      label: 'Options Data Source Label Field',
      name: 'optionsDataSourceLabelField',
      description:
        'The underlying field from the options data source used to provide the label for each option',
      editor: 'dropdown',
      function: {
        name: 'getDataSourceFields',
        values: [],
        params: ['element.optionsDataSource', false]
      },
      displayWhen: [
        { field: 'useDataSourceOptions', operator: '=', value: true }
      ],
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    },
    {
      label: 'Options Data Source Value Field',
      name: 'optionsDataSourceValueField',
      description:
        'The underlying field from the options data source used to provide the value for each option',
      editor: 'dropdown',
      function: {
        name: 'getDataSourceFields',
        values: [],
        params: ['element.optionsDataSource', false]
      },
      displayWhen: [
        { field: 'useDataSourceOptions', operator: '=', value: true }
      ],
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    },
    {
      label: 'Options Data Source Sub-Title Field',
      name: 'optionsDataSourceSubTitleField',
      description:
        'The underlying field from the options data source used to provide the sub-title for each option',
      editor: 'dropdown',
      function: {
        name: 'getDataSourceFields',
        values: [],
        params: ['element.optionsDataSource', false]
      },
      displayWhen: [
        { field: 'useDataSourceOptions', operator: '=', value: true }
      ],
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    },
    {
      label: 'Options Data Source Icon Field',
      name: 'optionsDataSourceIconField',
      description:
        'The underlying field from the options data source used to provide the icon name for each option',
      editor: 'dropdown',
      function: {
        name: 'getDataSourceFields',
        values: [],
        params: ['element.optionsDataSource', false]
      },
      displayWhen: [
        { field: 'useDataSourceOptions', operator: '=', value: true }
      ],
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    },
    {
      label: 'Options Data Source Image Field',
      name: 'optionsDataSourceImageField',
      description:
        'The underlying field from the options data source used to provide the image for each option',
      editor: 'dropdown',
      function: {
        name: 'getDataSourceFields',
        values: [],
        params: ['element.optionsDataSource', false]
      },
      displayWhen: [
        { field: 'useDataSourceOptions', operator: '=', value: true }
      ],
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    },
    {
      label: 'Hide Option Labels',
      name: 'hideLabels',
      editor: 'boolean',
      default: false,
      description: 'If true, option labels will be hidden.',
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    },
    {
      label: 'Hide Option Sub-Titles',
      name: 'hideSubTitles',
      editor: 'boolean',
      default: false,
      description: 'If true, option subtitles will be hidden.',
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    },
    {
      label: 'Hide Option Icons',
      name: 'hideIcons',
      editor: 'boolean',
      default: false,
      description: 'If true, option icons will be hidden.',
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    },
    {
      label: 'Option Labels',
      name: 'optionLabels',
      editor: 'textbox',
      description: 'Comma separated list of option labels.',
      default: 'option1,option2',
      options: [],
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    },
    {
      label: 'Option Values',
      name: 'optionValues',
      editor: 'textbox',
      description: 'Comma list of option values.',
      default: 'value1,value2',
      options: [],
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    },
    {
      label: 'Option Sub-Titles',
      name: 'optionSubTitles',
      editor: 'textbox',
      description: '(Optional) Comma list of subtitles for individual options.',
      default: 'subtitle1,subtitle2',
      options: [],
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    },
    {
      label: 'Use Different Option Icons',
      name: 'useDifferentOptionIcons',
      editor: 'switch',
      description: 'If true, will use a different icon for each option',
      default: false,
      options: [],

      group: ELEMENT_ATTRIBUTE_GROUP.IMAGERY
    },
    {
      label: 'Selected Option Icons',
      name: 'optionIconsSelected',
      editor: 'textbox',
      description:
        '(Optional) Comma list of hero icon names for individual options when selected. i.e. XMarkIcon. Leave blank to use the same selected and non-selected icon as defined in imagery',
      default: 'subtitle1,subtitle2',
      options: [],
      displayWhen: [
        { field: 'useDifferentOptionIcons', operator: '=', value: true }
      ],
      group: ELEMENT_ATTRIBUTE_GROUP.IMAGERY
    },
    {
      label: 'Non-Selected Option Icons',
      name: 'optionIconsNonSelected',
      editor: 'textbox',
      description:
        '(Optional) Comma list of hero icon names for individual options when selected. i.e. XMarkIcon. Leave blank to use the same selected and non-selected icon as defined in imagery',
      default: 'CogIcon,CogIcon',
      options: [],
      displayWhen: [
        { field: 'useDifferentOptionIcons', operator: '=', value: true }
      ],
      group: ELEMENT_ATTRIBUTE_GROUP.IMAGERY
    },
    {
      label: 'Option Font',
      name: 'font',
      editor: 'fontsize',
      description: 'The font settings of the text on each option',
      default: 14,
      group: ELEMENT_ATTRIBUTE_GROUP.FONTS
    },
    {
      label: 'Option Width',
      name: 'optionWidth',
      editor: 'number',
      description: 'The width of each option',
      default: 150,
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    },
    {
      label: 'Option Height',
      name: 'optionHeight',
      editor: 'number',
      description: 'The height of each option',
      default: 150,
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    },
    {
      label: 'Option Label Alignment',
      name: 'alignmentLabel',
      editor: 'alignment',
      description: 'The alignment of the label within its option container',
      default: 'center',
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    },
    {
      label: 'Option Margin',
      name: 'optionMargin',
      editor: 'boundary',
      description: 'The margin around an option container',
      default: '0 0 0 0',
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    },
    {
      label: 'Option Padding',
      name: 'optionPadding',
      editor: 'boundary',
      description: 'The padding around an option container',
      default: '0 0 0 0',
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    },
    {
      label: 'Option Icon Alignment',
      name: 'alignmentIcon',
      editor: 'alignment',
      description: 'The alignment of the icon within its option container',
      default: 'center',
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    },
    {
      label: 'Option Sub-Title Alignment',
      name: 'alignmentSubTitle',
      editor: 'alignment',
      description: 'The alignment of the sub-title within its option container',
      default: 'center',
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    },
    {
      label: 'Conditional Colors',
      name: 'conditionalColors',
      editor: 'textarea',
      description:
        'Setup conditional colors based on the selected option in the form of a JSON array. i.e. [ { "value": "yes", colors: [ { "selectedColor" : "#98098" }, {  any other color field } ] ]',
      default: '',
      group: ELEMENT_ATTRIBUTE_GROUP.COLORS
    },
    {
      label: 'Selected Option Text Color',
      name: 'selectedColor',
      editor: 'color',
      description: 'The text color of a selected option',
      default: '#000000',
      group: ELEMENT_ATTRIBUTE_GROUP.COLORS
    },
    {
      label: 'Option Sub-Title Font',
      name: 'subtitleFont',
      editor: 'fontsize',
      description: 'The font settings of the text on each option',
      default: 14,
      group: ELEMENT_ATTRIBUTE_GROUP.FONTS
    },
    {
      label: 'Selected Option Sub-Title Text Color',
      name: 'selectedColorSubTitle',
      editor: 'color',
      description: 'The text color of a selected option subtitle',
      default: '#000000',
      group: ELEMENT_ATTRIBUTE_GROUP.COLORS
    },
    {
      label: 'Selected Option Background Color',
      name: 'selectedBackgroundColor',
      editor: 'color',
      description: 'The background color of a selected option',
      default: '#000000',
      group: ELEMENT_ATTRIBUTE_GROUP.COLORS
    },
    {
      label: 'Selected Option Border Color',
      name: 'selectedBorderColor',
      editor: 'color',
      description: 'The border color of an option when it is selected',
      default: '#000000',
      group: ELEMENT_ATTRIBUTE_GROUP.COLORS
    },
    {
      label: 'Selected Option Border Width',
      name: 'selectedBorderWidth',
      editor: 'number',
      description: 'The border width of an option when it is selected',
      default: 0,
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    },
    {
      label: 'Selected Option Border Radius',
      name: 'selectedBorderRadius',
      editor: 'number',
      description: 'The border radius of an option when it is selected',
      default: 0,
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    },
    {
      label: 'Selected Option Border Style',
      name: 'selectedBorderStyle',
      editor: 'dropdown',
      options: [
        { label: 'Solid', value: 'solid' },
        { label: 'Dotted', value: 'dotted' },
        { label: 'Dashed', value: 'dashed' }
      ],
      description: 'The border style of an option when it is selected',
      default: 'solid',
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    },
    {
      label: 'Non-Selected Option Text Color',
      name: 'nonSelectedColor',
      editor: 'color',
      description: 'The text color of an option when it is not selected',
      default: '#000000',
      group: ELEMENT_ATTRIBUTE_GROUP.COLORS
    },
    {
      label: 'Non-Selected Option Sub-Title Color',
      name: 'nonSelectedSubTitleColor',
      editor: 'color',
      description:
        'The text color of an option sub-title when it is not selected',
      default: '#000000',
      group: ELEMENT_ATTRIBUTE_GROUP.COLORS
    },
    {
      label: 'Non-Selected Option Background Color',
      name: 'nonSelectedBackgroundColor',
      editor: 'color',
      description: 'The background color of an option when it is not selected',
      default: '#000000',
      group: ELEMENT_ATTRIBUTE_GROUP.COLORS
    },
    {
      label: 'Non-Selected Option Border Color',
      name: 'nonSelectedBorderColor',
      editor: 'color',
      description: 'The border color of an option when it is not selected',
      default: '#000000',
      group: ELEMENT_ATTRIBUTE_GROUP.COLORS
    },
    {
      label: 'Non-Selected Option Border Width',
      name: 'nonSelectedBorderWidth',
      editor: 'number',
      description: 'The border width of an option when it is not selected',
      default: 0,
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    },
    {
      label: 'Non-Selected Option Border Radius',
      name: 'nonSelectedBorderRadius',
      editor: 'number',
      description: 'The border radius of an option when it is not selected',
      default: 0,
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    },
    {
      label: 'Non-Selected Option Border Style',
      name: 'nonSelectedBorderStyle',
      editor: 'dropdown',
      options: [
        { label: 'Solid', value: 'solid' },
        { label: 'Dotted', value: 'dotted' },
        { label: 'Dashed', value: 'dashed' }
      ],
      description: 'The border style of an option when it is not selected',
      default: 'solid',
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    },
    {
      name: 'selectedIconMargin',
      label: 'Selected Icon Margin',
      description: '',
      editor: 'boundary',
      type: 'string',
      default: '0 0 0 2',
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    },
    {
      name: 'selectedIcon',
      label: 'Selected Icon',
      description: 'The icon to display on a selected radio item',
      editor: 'icon',
      type: 'string',
      default: 'DocumentIcon',
      group: ELEMENT_ATTRIBUTE_GROUP.IMAGERY
    },
    {
      name: 'selectedIconSize',
      label: 'Selected Icon Size',
      description: 'The size of a selection radio item',
      editor: 'iconsize',
      type: 'number',
      default: 6,
      group: ELEMENT_ATTRIBUTE_GROUP.IMAGERY
    },
    {
      label: 'Selected Icon Color',
      name: 'selectedIconColor',
      editor: 'color',
      description: 'The color of the selected radio item',
      default: '#000000',
      group: ELEMENT_ATTRIBUTE_GROUP.COLORS
    },
    {
      name: 'nonSelectedIconMargin',
      label: 'Non-Selected Icon Margin',
      description: '',
      editor: 'boundary',
      type: 'string',
      default: '0 0 0 2',
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    },
    {
      name: 'nonSelectedIcon',
      label: 'Non-Selected Icon',
      description: 'The icon to display on a non-selected radio item',
      editor: 'icon',
      type: 'string',
      default: 'DocumentIcon',
      group: ELEMENT_ATTRIBUTE_GROUP.IMAGERY
    },
    {
      name: 'nonSelectedIconSize',
      label: 'Non-Selected Icon Size',
      description: 'The size of a non-selected radio item',
      editor: 'iconsize',
      type: 'number',
      default: 6,
      group: ELEMENT_ATTRIBUTE_GROUP.IMAGERY
    },
    {
      label: 'Non-Selected Icon Color',
      name: 'nonSelectedIconColor',
      editor: 'color',
      description: 'The color of a non-selected radio item',
      default: '#000000',
      group: ELEMENT_ATTRIBUTE_GROUP.COLORS
    },
    {
      label: 'Use Background Images',
      name: 'useBackgroundImages',
      editor: 'boolean',
      description:
        'If true will use a background image instead of a background color on each option',
      displayWhen: [
        { field: 'useDataSourceOptions', operator: '!=', value: true }
      ],
      group: ELEMENT_ATTRIBUTE_GROUP.IMAGERY
    },
    {
      label: 'Selected Background Image',
      name: 'selectedBackgroundImage',
      editor: 'image',
      description:
        'The background image(s) to used on a checked option. Upload the same number of images as there are options.',
      mediaLibraryStoreIn: 'custom_folder',
      mediaLibraryPath: 'apps',
      allowMultipleUploads: true,
      group: ELEMENT_ATTRIBUTE_GROUP.IMAGERY,
      displayWhen: [
        { field: 'useBackgroundImages', operator: '=', value: true }
      ]
    },
    {
      label: 'Non-Selected Background Image',
      name: 'nonSelectedBackgroundImage',
      editor: 'image',
      mediaLibraryStoreIn: 'custom_folder',
      mediaLibraryPath: 'apps',
      allowMultipleUploads: true,
      description:
        'The background image(s) to used on a non-checked options. Upload the same number of images as there are options.',
      group: ELEMENT_ATTRIBUTE_GROUP.IMAGERY,
      displayWhen: [
        { field: 'useBackgroundImages', operator: '=', value: true }
      ]
    }
  ]
};

export default RadioButtonGroupElementFields;
